var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrunchbase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.8 0H3.2A3.2 3.2 0 000 3.2v25.6C0 30.6 1.4 32 3.2 32h25.6c1.8 0 3.2-1.4 3.2-3.2V3.2C32 1.4 30.6 0 28.8 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0287d1",
    d: "M28.8 0H3.2A3.2 3.2 0 000 3.2v25.6C0 30.6 1.4 32 3.2 32h25.6c1.8 0 3.2-1.4 3.2-3.2V3.2C32 1.4 30.6 0 28.8 0zM9.4 19.3c1.4.6 3 0 3.7-1.4h2.2c-1.3 5.6-9.7 4.6-9.7-1.2s8.4-6.8 9.7-1.1h-2.2a2.8 2.8 0 10-3.7 3.7zm15.1 1.1c-.4.4-.9.7-1.4.9a5 5 0 01-4.5-.6v.6h-2V7.2h2v5.4a5 5 0 012.4-.8h.3c4.6 0 6.7 5.7 3.2 8.6zm-.3-3.7c0 1.6-1.2 2.9-2.8 2.9s-2.8-1.3-2.8-2.9c0-3.6 5.5-3.6 5.6 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrunchbase);
export default __webpack_public_path__ + "static/media/Crunchbase.9dade544.svg";
export { ForwardRef as ReactComponent };